import style from './Infrastructure.module.scss';
import SectionTitle from '../../../../components/SectionTitle';
import TextCard from './components/TextCard/TextCard';
import { useLayoutEffect, useRef } from 'react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import gsap from 'gsap';
import { useMediaQuery } from 'usehooks-ts';

gsap.registerPlugin(ScrollTrigger);

const InfrastructureSection = () => {
  const scopeRef = useRef(null);
  const canvasRef = useRef(null);
  const panelsContainer = useRef(null);
  const isMobile = useMediaQuery('(max-width:991px)');

  useLayoutEffect(() => {
    let ctx = gsap.context(() => {
      let context = canvasRef.current.getContext('2d');
      canvasRef.current.width = 1920;
      canvasRef.current.height = 1080;

      let frameCount = 158;
      const currentFrame = (index) =>
        `./assets/img/server-sequence/${(index + 1)
          .toString()
          .padStart(5, '0')}.png`;

      let images = [];
      let frames = {
        frame: 0,
      };

      for (let i = 0; i < frameCount; i++) {
        let img = new Image();
        img.src = currentFrame(i);
        images.push(img);
      }

      images[0].onload = render;

      function render() {
        context.clearRect(
          0,
          0,
          canvasRef.current.width,
          canvasRef.current.height
        );
        context.drawImage(images[frames.frame], 0, 0);
      }

      const panels = gsap.utils.toArray('#server-container .panel');

      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: '#server-container',
          pin: true,
          start: 'top top',
          end: '+=1000',
          scrub: 0.5,
          markers: false,
        },
      });
      let tlServer = gsap.timeline({
        onUpdate: render,
        scrollTrigger: {
          trigger: '#server-container',
          start: 'top top',
          end: '+=1000',
          scrub: 1,
          markers: false,
        },
      });

      tl.fromTo(panels[0], { opacity: 1 }, { opacity: 0 });
      tl.to(panels[1], { opacity: 1 });
      tl.to(panels[1], { opacity: 0 });
      tl.to(panels[2], { opacity: 1 });
      tlServer.to(
        frames,
        {
          frame: frameCount - 1,
          snap: 'frame',
          ease: 'none',
          duration: 1,
        },
        0
      );
    }, scopeRef);
    return () => ctx.revert();
  }, []);

  return (
    <section ref={scopeRef} className={style.infrastructure}>
      <div
        ref={panelsContainer}
        id='server-container'
        className={`${style.con} container `}
      >
        <SectionTitle className={style.infrastructure__title}>
          Our <br /> <span>Infrastructure</span>
        </SectionTitle>
        <div className={style.infrastructureBody}>
          <canvas
            ref={canvasRef}
            className={style.infrastructureBody__server}
          ></canvas>
          <div className={style.infrastructureBody__text}>
            <TextCard
              className={`${style.infrastructureBody__textItem} panel`}
              title={'1. Data'}
              text={
                'Our investment approach is based on <span>data-driven insights</span> from a wide range of markets and trading platforms. At the heart of our model development strategy is our <span>commitment to data quality</span> - it must be accurate, clean and easily accessible. This allows our quantitative analysts to <span>quickly connect to diverse datasets, taking our approach to new heights.</span>'
              }
            />
            <TextCard
              className={`${style.infrastructureBody__textItem} panel`}
              title={'2. Risk Management'}
              text={
                'Our <span>robust real-time risk management system</span> allows us to be vigilant at all levels. We are <span>constantly evaluating potential vulnerabilities, stress testing our strategies and responding to market</span> events to ensure optimal security and performance. Our approach covers both <span>pre-trade and post-trade methods</span> as well as counterparty risks'
              }
            />
            <TextCard
              className={`${style.infrastructureBody__textItem} panel`}
              title={'3. Trading System'}
              text={
                'Our trading systems are designed for <span>seamless strategy integration, backtesting and optimal execution.</span> The technical team takes responsibility for the integration with the trading platforms, and also provides our specialists with the necessary tools, <span>allowing quants to focus on the development of signal modules.</span> The <span>reliability</span> of our trading systems is evidenced by the high volume of orders they have successfully managed over the years.'
              }
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default InfrastructureSection;
